import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function DeviceManagementTableRowSkeleton({ index }) {
    return (
        <tr key={index}>
            <td width="70%"><Skeleton variant="text" width="80%" height={24} /></td>
            <td><Skeleton variant="rectangular" width={24} height={24} className="oct_skeleton-radius-4" /></td>
        </tr>
    );
}

export default DeviceManagementTableRowSkeleton;
